import { render, staticRenderFns } from "./address-row.vue?vue&type=template&id=c5511a44&scoped=true"
import script from "./address-row.vue?vue&type=script&setup=true&lang=js"
export * from "./address-row.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5511a44",
  null
  
)

export default component.exports